import CouponUpdate from './CouponUpdate'
export {CouponUpdate}
export default CouponUpdate
